import {USER_USERS, DESK_SETTING, USER_ACCOUNTS, ACCOUNT_USERS} from './endpoint'
import {
  UPDATE_PROFILE,
  UPDATE_PROFILE_PASSWORD,
  GET_USERS,
  DELETE_USER,
  GET_TEMPLATE,
  CREATE_TEMPLATE,
  DELETE_TEMPLATE,
  GET_SINGLE_TEMPLATE,
  EDIT_SINGLE_TEMPLATE,
  DELETE_TEMPLATE_ATTACHMENT,
  DELETE_TAG,
  CREATE_TAG,
  GET_TAGS,
  GET_TRAIL_LOGS,
  GET_TAGS_SETTING,
  EDIT_TAG_SETTING,
  GET_NOTIFICATION,
  PUT_NOTIFICATION,
  UPDATE_GENERAL_SETTING,
  GET_GENERAL_SETTING,
  ALLOW_USER_ACCESS,
} from './types'
import {apiAction} from './api'

export function updateProfile(data) {
  return apiAction({
    url: `${USER_USERS}/me`,
    method: 'PUT',
    label: UPDATE_PROFILE,
    data,
    showToast: true,
    successMessage: 'Profile Updated',
  })
}

export function updateProfilePicture(data) {
  return apiAction({
    url: `${USER_USERS}/avatar`,
    method: 'POST',
    label: 'UPDATE_AVATAR',
    data,
    contentType: 'multipart/form-data',
  })
}

export function deleteProfilePicture() {
  return apiAction({
    url: `${USER_USERS}/avatar`,
    method: 'DELETE',
    label: 'DELETE_AVATAR',
    showToast: true,
    successMessage: 'Avatar Deleted',
  })
}

export function changePasswordProfile(data) {
  return apiAction({
    url: `${USER_ACCOUNTS}/password`,
    method: 'PUT',
    label: UPDATE_PROFILE_PASSWORD,
    data,
    showToast: true,
    successMessage: 'Password Changed',
  })
}

export function getUsers(params) {
  const keys = Object.keys(params || {})
  const query = keys
    .filter(key => params[key])
    .map(key => `${key}=${params[key]}`)
    .join('&')

  return apiAction({
    url: `${ACCOUNT_USERS}?${query}`,
    method: 'GET',
    label: GET_USERS,
  })
}

export function deleteUser(ids) {
  return apiAction({
    url: `${USER_ACCOUNTS}/users`,
    method: 'DELETE',
    label: DELETE_USER,
    data: ids,
    showToast: true,
    successMessage: 'User Deleted',
  })
}

export function createQuickReply(data) {
  return apiAction({
    url: `${DESK_SETTING}/automation/templates`,
    method: 'POST',
    label: CREATE_TEMPLATE,
    data,
    showToast: true,
    successMessage: 'Canned Response Created',
  })
}

export function getCannedResponses(data) {
  return apiAction({
    url: `${DESK_SETTING}/automation/templates`,
    method: 'GET',
    label: GET_TEMPLATE,
    data,
  })
}

export function deleteCannedResponses(id) {
  return apiAction({
    url: `${DESK_SETTING}/automation/templates/${id}`,
    method: 'DELETE',
    label: DELETE_TEMPLATE,
    showToast: true,
    successMessage: 'Canned Response Deleted',
  })
}

export function singleCannedResponses(id) {
  return apiAction({
    url: `${DESK_SETTING}/automation/templates/${id}`,
    method: 'GET',
    label: GET_SINGLE_TEMPLATE,
  })
}

export function editCannedResponse(id, data) {
  return apiAction({
    url: `${DESK_SETTING}/automation/templates/${id}`,
    method: 'PUT',
    label: EDIT_SINGLE_TEMPLATE,
    data,
    showToast: true,
    successMessage: 'Canned Response Updated',
  })
}

export function deleteTemplateAttachment(id, attachmentId) {
  const idString = attachmentId.join(',')

  return apiAction({
    url: `${DESK_SETTING}/automation/templates/${id}/attachment/${idString}`,
    method: 'DELETE',
    label: DELETE_TEMPLATE_ATTACHMENT,
  })
}

// Tags-------------->

export function createTagSettings(data) {
  return apiAction({
    url: `${DESK_SETTING}/labels`,
    method: 'POST',
    label: CREATE_TAG,
    data,
    showToast: true,
    successMessage: 'Tag Created',
  })
}

export function getTags() {
  return apiAction({
    url: `${DESK_SETTING}/labels`,
    method: 'GET',
    label: GET_TAGS,
  })
}

export function deleteTags(id) {
  return apiAction({
    url: `${DESK_SETTING}/labels/${id}`,
    method: 'DELETE',
    label: DELETE_TAG,
    showToast: true,
    successMessage: 'Tag Deleted',
  })
}

export function getTag(id) {
  return apiAction({
    url: `${DESK_SETTING}/labels/${id}`,
    method: 'GET',
    label: GET_TAGS_SETTING,
  })
}

export function editTag(data, id) {
  return apiAction({
    url: `${DESK_SETTING}/labels/${id}`,
    method: 'PUT',
    label: EDIT_TAG_SETTING,
    data,
    showToast: true,
    successMessage: 'Tag Updated',
  })
}

export function getTrailLogs(data) {
  return apiAction({
    url: `${DESK_SETTING}/qa-audit/trail-logs`,
    method: 'POST',
    label: GET_TRAIL_LOGS,
    data,
  })
}

export function getNotification() {
  return apiAction({
    url: `${DESK_SETTING}/notifications`,
    method: 'GET',
    label: GET_NOTIFICATION,
  })
}

export function changeNotification(data) {
  return apiAction({
    url: `${DESK_SETTING}/notifications`,
    method: 'PUT',
    label: PUT_NOTIFICATION,
    data,
    showToast: true,
    successMessage: 'Notification Updated',
  })
}

export function getGeneralSettings() {
  return apiAction({
    url: `${DESK_SETTING}/general-setting`,
    method: 'GET',
    label: GET_GENERAL_SETTING,
  })
}
export function updateGeneralSettings(data) {
  return apiAction({
    url: `${DESK_SETTING}/general-setting`,
    method: 'POST',
    data,
    showToast: true,
    successMessage: 'Settings Updated',
    label: UPDATE_GENERAL_SETTING,
  })
}

export function allowUserAccess(id) {
  return apiAction({
    url: `${USER_USERS}/access/${id}`,
    method: 'PUT',
    label: ALLOW_USER_ACCESS,
    showToast: true,
  })
}
